export enum RelationshipTypesEnum {
    None = 0,
    Client = 1,
    ContactPerson = 2,
    Employer = 5,
    Employee = 6,
    Parent = 7,
    Child = 8,
    Therapist = 9,
    Partner = 10,
    Other = 11
}

export const RelationshipTypesLabels: Record<number, string> = {
    [RelationshipTypesEnum.None]: "relation-relation.enum.none",
    [RelationshipTypesEnum.Client]: "relation-relation.enum.client",
    [RelationshipTypesEnum.ContactPerson]: "relation-relation.enum.contact-person",
    [RelationshipTypesEnum.Employer]: "relation-relation.enum.employer",
    [RelationshipTypesEnum.Employee]: "relation-relation.enum.employee",
    [RelationshipTypesEnum.Parent]: "relation-relation.enum.parent",
    [RelationshipTypesEnum.Child]: "relation-relation.enum.child",
    [RelationshipTypesEnum.Therapist]: "relation-relation.enum.therapist",
    [RelationshipTypesEnum.Partner]: "relation-relation.enum.partner",
    [RelationshipTypesEnum.Other]: "relation-relation.enum.other",
}

export const RelationshipTypesOpposites: Record<number, number> = {
    [RelationshipTypesEnum.None]: RelationshipTypesEnum.None,
    [RelationshipTypesEnum.Client]: RelationshipTypesEnum.Therapist,
    [RelationshipTypesEnum.ContactPerson]: RelationshipTypesEnum.None,
    [RelationshipTypesEnum.Employer]: RelationshipTypesEnum.Employee,
    [RelationshipTypesEnum.Employee]: RelationshipTypesEnum.Employer,
    [RelationshipTypesEnum.Parent]: RelationshipTypesEnum.Child,
    [RelationshipTypesEnum.Child]: RelationshipTypesEnum.Parent,
    [RelationshipTypesEnum.Therapist]: RelationshipTypesEnum.Client,
    [RelationshipTypesEnum.Partner]: RelationshipTypesEnum.Partner,
    [RelationshipTypesEnum.Other]: RelationshipTypesEnum.Other
}